module.exports = __webpack_public_path__ + "img/自动重传.12e23839.svg";